import { generatePath, useLocation, useParams } from 'react-router';
import { useEffect } from 'react';

import { AppRoutes } from '@/constants';
import { navigate } from '@/providers';
import { ChevronLeftIcon, EditIcon } from '@/assets/icons';
import { Button, Loading } from '@/components/common';

import RoleAssignmentDetailsCard from './RoleAssignmentDetailsCard';
import { useRoleAssignmentDetailsQuery } from '@/features/role-assignments/hooks';

const RoleAssignmentDetails = () => {
  const { id } = useParams();
  const location = useLocation();
  const { data, error, isFetching } = useRoleAssignmentDetailsQuery(id || '');

  const handleBack = () => {
    const hasHistory = location.key !== 'default';
    if (hasHistory) {
      window.history.back();
    } else {
      navigate(AppRoutes.ROLE_ASSIGNMENTS);
    }
  };

  useEffect(() => {
    if (error || (!isFetching && !data)) {
      navigate(AppRoutes.NOT_FOUND, { replace: true });
    }
  }, [error, isFetching, data]);

  return (
    <div className="flex flex-col gap-base mt-xl mb-24 text-brand-primary-darkest">
      {/* Back Button */}
      <Button
        variant="link"
        className="text-neutral-n7 self-start"
        prefixIcon={<ChevronLeftIcon />}
        onClick={handleBack}
      >
        Back to Role Assignment
      </Button>

      {/* Header with Title and Edit Button */}
      <div className="flex items-center justify-between gap-4 pb-base-plus">
        <h1
          className="text-h1 font-bold text-ellipsis flex-1 overflow-hidden whitespace-nowrap"
          title={data?.fullName}
        >
          {data?.fullName}
        </h1>
        <Button
          className="w-[104px]"
          variant="primary"
          borderRadius="soft"
          prefixIcon={<EditIcon />}
          onClick={() => navigate(generatePath(AppRoutes.ROLE_ASSIGNMENT_UPDATE, { id: id }))}
        >
          Edit
        </Button>
      </div>

      {/* Details Card */}
      {isFetching && <Loading fullScreen />}
      {data && <RoleAssignmentDetailsCard roleAssignmentDetails={data} />}
    </div>
  );
};

export default RoleAssignmentDetails;
